import styled from 'styled-components';
import { Text } from '../../Text';
import { colors, mixins, media } from '../../../css';

export const overrideSwitchStyles = () => ({
  thumb: {
    width: 18,
    height: 18,
    boxShadow: 'none'
  },

  switchBase: {
    color: colors.colorGrey04,
    '&$checked': {
      color: colors.colorWhite
    }
  },
  checked: {
    transform: 'translate(23px, -1px)',
    '& + $track': {
      opacity: '1 !important',
      borderColor: colors.colorBlue
    }
  },
  disabled: {
    '& + $track': {
      opacity: 1
    },
    '& $thumb': {
      boxShadow: `0 0 0 1px #c8c8c8`
    },
    '&$switchBase': {
      color: '#eae9ea',
      '& + $track': {
        borderColor: '#c8c8c8',
        backgroundColor: '#fbfafb',
        opacity: 1
      }
    }
  },
  track: {
    borderRadius: 26 / 2,
    width: 50,
    height: 26,
    marginTop: -7,
    marginLeft: -8,
    marginRight: -6,
    border: '1px solid',
    borderColor: colors.colorGrey03,
    backgroundColor: colors.colorGrey05,
    opacity: 1
  }
});

export const StyledCopyBody = styled(Text.CopyBody)`
  margin-top: ${mixins.pxToRem(12)};

  ${media.greaterThan('lg')`
    margin-top: ${mixins.pxToRem(10)};
  `};
`;
